import { nanoid } from 'nanoid';
import type { ComponentLayer } from '@types';

export function generateCLayerId() {
  return `cl_${nanoid()}`;
}

export function renewCLayerId(list: ComponentLayer[] = []): ComponentLayer[] {
  if (!list.length) return [];
  return list.map((x) => ({
    ...x,
    id: generateCLayerId(),
  }));
}
